module.exports = __webpack_public_path__ + "static/media/hydpurple.6ceed0d9.svg";